<template>
  <div>
    <div class="welfareBox mt15">
      <div class="descriptionTitle">
        <span  class='descriptionTitle_inner'>其他优惠券</span>
      </div>
      <div class="otherCoupon_wrapper">
        <div class="list" v-for="item in moreCoupons">
          <div class="list_l">
            <div class="list_pic_wrapper">
              <img :src="item.logo" class="list_pic_wrapper"/>
            </div>
            <div class="list_text_wrapper">
              <p class="t1">{{item.title}}</p>
              <p class="t2">{{item.company}}</p>
            </div>
          </div>
          <div class="list_r">
            <div class="circle_wrapper">
              <div class="circle1"></div>
              <div class="circle2"></div>
            </div>
            <button class="getBtn" @click="getLink(item.link,needClip)">
              点击<br/>领取
            </button>
          </div>
        </div>

      </div>

</div>
    </div>
</template>
<script type = "text/ecamscript-6">
export default {
  name:"otherCoupons",
  props:['moreCoupons','needClip',"getLink"],
  data(){
    return{

    }
  },
  created(){
    //this.login()
  },
  methods:{
    // getMoreCouponsLink(link) {
    //     if(this.needClip==0){
    //       window.location = link
    //     }
    //     else{
    //       //复制
    //     }
    // }
  },
}
</script>
<style lang="stylus">
  .welfareBox
    width: 100%
    padding: 34px 30px
    background: #fff
    box-sizing: border-box
    .descriptionTitle
      padding: 20px 0
      border-bottom: 1px solid #ddd
      /*px*/
    .otherCoupon_wrapper
      padding-top:10
      .list
        width:100%
        height:146px
        display:flex
        border-radius:15px
        overflow:hidden
        margin-top:20px
        .list_l
          flex:0 0 530px
          padding:28px 20px
          box-sizing:border-box
          background:#f5f5f5
          display:flex
          .list_pic_wrapper
            flex:0 0 88px
            .list_pic_wrapper
              width:88px
              height:88px
              border-radius:44px
              border:1px solid #dddddd
              /*px*/
          .list_text_wrapper
            flex:1
            padding-left:15px
            line-height:44px
            .t1
              font-size:24px
              color:#333
            .t2
              font-size:24px
              color:#666
        .list_r
          flex:1
          background:#e8e8e8
          position:relative
          .circle_wrapper
            position:absolute
            left:-12px
            top:0px
            width:24px
            height:146px
            .circle1
              width:24px
              height:8px
              border-radius:0 0 12px 12px
              background:#fff
              position:absolute
              top:0px;
              left:0px
            .circle2
              width:24px
              height:8px
              border-radius:12px 12px 0 0
              background:#fff
              position:absolute
              bottom:0px
              left:0px
          .getBtn
            position:absolute
            left:50%
            top:50%
            transform:translate(-50%,-50%)
            font-size:24px
            color:#ff4400
            border:0px


</style>



// WEBPACK FOOTER //
// src/components/welfare/otherCoupons.vue